import React from 'react';

const updateActiveDropdown = <T>({
  dropdown,
  activeDropdown,
  setActiveDropdown,
}: {
  dropdown?: T;
  activeDropdown?: T | null;
  setActiveDropdown: React.Dispatch<React.SetStateAction<T | null>>;
}) => {
  if (!dropdown || activeDropdown === dropdown) {
    setActiveDropdown(null);
    return;
  }
  setActiveDropdown(dropdown);
};

export default updateActiveDropdown;
